import { SUPPORT_CONTACT } from "@/constants";
import { useWhitelabel } from "@/providers";

/**
 * Resolves the support email for inline "contact support at …" copy (OTP error
 * messages, verification message bodies, etc.).
 *
 * Whitelabel customers get their own brand support email; everyone else gets the
 * platform default (`SUPPORT_CONTACT.email`). This centralises what used to be a
 * hardcoded `operations@universemoney.io` repeated across the `otp.*` strings,
 * so whitelabels surface their own contact instead of Universe's.
 *
 * Unlike the dedicated `/support` page (which can hide the platform fallback for
 * whitelabels that set `showFallbackSupport: false`), inline sentence copy always
 * needs a concrete address, so this always resolves to a non-empty email.
 */
export function useSupportEmail(): string {
  const whitelabel = useWhitelabel();
  return (
    (whitelabel.isWhitelabel && whitelabel.supportEmail) ||
    SUPPORT_CONTACT.email
  );
}
